class ImageGrid extends WebPageComponentClass {
  constructor(element) {
    super(element);

    this.images = new DomQuery(this.element).getChild(WithClass("Images"));
  }

  async addFile(file) {
    this.addImage(file);
    await application.pageHandler.persistOfflinePage();
  }

  async getImage(id) {
    const file = await application.pageHandler.retrieveThumbnail(id);

    if (file && file.thumbnail !== null) {
      if (file.uuid) {
        // TODO: For now we assume that the uuid is used as name of the file.
        //       We should probably use a more robust strategy.
        const image = this.images.querySelector(`.Image > [data--name="${file.uuid}"]`)?.parentElement;

        if (image)
          image.remove();
      }

      this.addImage(file);
    }
  }

  addImage(file) {
    const image = document.createElement("img");
    image.src = URL.createObjectURL(new Blob([file.thumbnail]));
    image.title = file.name;

    const container = document.createElement("div");
    container.classList.add("Image");
    container.dataset.Id = file.id;
    container.appendChild(image);

    if (file.uuid)
      container.id = file.uuid;

    this.updateImageState(container, file.state);
    this.images.appendChild(container);
  }

  updateImageState(image, state) {
    image.classList.remove("Successful", "Uploading", "Error");

    if (state === FileUploadState.Successful)
      image.classList.add("Successful");
    else if (state in [FileUploadState.Initial, FileUploadState.Preparing, FileUploadState.Prepared, FileUploadState.Uploading])
      image.classList.add("Uploading");
    else
      image.classList.add("Error");
  }

  handleEvent(event) {
    if (event instanceof FileUploadedEvent)
      this.addFile(event.data);
    else if (event instanceof FileUploadStatusChangedEvent) {
      const image = this.images.querySelector(`.Image[data--id="${event.upload.id}"]`);

      if (image)
        this.updateImageState(image, event.upload.state);
    }
    else
      super.handleEvent(event);
  }

  load(value) {
    if (Array.isArray(value)) {
      for (const element of value)
        this.getImage(element);
    }
  }

  save() {
    const result = new Array();

    for (const image of this.images.childNodes)
      if (image.dataset.Id)
        result.push(parseInt(image.dataset.Id));

    return result;
  }
}

interactivityRegistration.register("ImageGrid", (element) => { return new ImageGrid(element) });
